import { combineReducers } from 'redux'
import merge from 'lodash/merge'
import { RECEIVE_PRODUCTS, RECEIVE_PRODUCT, RECEIVE_PRODUCT2 } from '../actions/product-actions'
import { RESET_STORE } from '../actions/currentUser-actions'

const searchResults = (state = [], action) => {
  switch(action.type) {
    case RECEIVE_PRODUCTS: return merge([], action.products, {query: action.query})
    case RESET_STORE: return []
    default: return state
  }
}

const detail = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_PRODUCT: return action.product
    case RESET_STORE: return {}
    default: return state
  }
}

const licensesActivePercentage = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_PRODUCT2: return action.data
    case RESET_STORE: return {}
    default: return state
  }
}

export default combineReducers({
  searchResults,
  detail,
  licensesActivePercentage
})
